export default {
  statusText: (thermostat) => ({
    connecting: 'Hold tight...we’re finishing up your connection',
    connected: `Great! You successfully connected your ${thermostat}`,
    failed: 'Oh no! Something went wrong. Please go back and try again',
  }),
  statusSubText: {
    connected:
      'You’ll be taken back to Optiwatt shortly. Click Continue to go back now.',
  },
}
